
import { Component, Vue, Prop } from 'vue-property-decorator';
import { cloneDeep, findIndex } from 'lodash';
import { namespace } from 'vuex-class';
import Slide from '@/interfaces/models/Slide';
import { EventBus } from '../event-bus';

let initialSelectionIndex: number | null = null;

const cart = namespace('cart');

@Component
export default class CartSelectionBoundary extends Vue {
  @Prop({ type: Array, required: true }) items!: string[];
  @Prop({ type: Object, required: true }) itemInMap!: { [key: string]: any };

  @cart.Mutation('addSelection') addToCart!: (slide: Slide) => void;
  @cart.Mutation('addManySelections') addManyToCart!: (slide: Slide[]) => void;

  mounted() {
    EventBus.$on('shift-to-cart', () => {
      initialSelectionIndex = null;
    });
  }

  select(select: { id: string; key: 'shift' | 'ctrl' }) {
    const slides = cloneDeep(this.items);
    if (select) {
      const slide = cloneDeep(this.itemInMap[select.id]);
      const index = findIndex(slides, y => y === select.id);

      switch (select.key) {
        case 'shift':
          let range: (string | Slide)[] = [];
          if (initialSelectionIndex !== null && index !== initialSelectionIndex) {
            // range selection
            if (index > initialSelectionIndex) {
              // forward range
              range = slides.slice(initialSelectionIndex, index + 1);

              const selectedItems = range.map(i => this.itemInMap[i as string]);

              this.addManyToCart(selectedItems as Slide[]);
            } else {
              range = slides.slice(index, initialSelectionIndex + 1);
              const selectedItems = range.map(i => this.itemInMap[i as string]);

              this.addManyToCart(selectedItems as Slide[]);
              // backward range
            }
          } else {
            initialSelectionIndex = index;
            this.addToCart(slide);
          }

          break;
        case 'ctrl':
          initialSelectionIndex = index;

          this.addToCart(slide);
          break;
      }
    }
  }

  render() {
    return this.$scopedSlots.default!({
      selectFn: this.select
    });
  }
}
